import { render, staticRenderFns } from "./FooterBox.vue?vue&type=template&id=9c3e52c0&scoped=true&"
import script from "./FooterBox.vue?vue&type=script&lang=js&"
export * from "./FooterBox.vue?vue&type=script&lang=js&"
import style0 from "./FooterBox.vue?vue&type=style&index=0&id=9c3e52c0&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c3e52c0",
  null
  
)

export default component.exports